module.exports = __webpack_public_path__ + "static/media/kodfit_logo_large.c99639aa.svg";